export function useFeatureFlags() {
  return {
    isSettingsEnabled: true,
    isSupportEnabled: true,
  };
}
